import React, { useState, useEffect } from "react";
import GrainsOilSeeds from "./SubClasses/GrainsOilSeeds";
import Livestock from "./SubClasses/Livestock";
import Softs from "./SubClasses/Softs";
import Energies from "./SubClasses/Energies";
import Currencies from "./SubClasses/Currencies";
import Header from "./FuturesHeader";
import Config from "../../config/config";

const Futures = () => {
  const [currentTab, setTab] = useState(0);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  // Track loading state for each tab
  const [tabLoadingStates, setTabLoadingStates] = useState({
    grainsOilSeeds: true,
    livestock: true,
    softs: true,
    energies: true,
    currencies: true,
  });

  // Function to handle tab loading completion
  const handleTabLoadComplete = (tabName) => {
    setTabLoadingStates((prev) => ({
      ...prev,
      [tabName]: false,
    }));
  };

  // Create tabs with onLoadComplete handlers
  const tabs = [
    <GrainsOilSeeds
      key="grainsOilSeeds"
      onLoadComplete={() => handleTabLoadComplete("grainsOilSeeds")}
    />,
    <Livestock
      key="livestock"
      onLoadComplete={() => handleTabLoadComplete("livestock")}
    />,
    <Softs key="softs" onLoadComplete={() => handleTabLoadComplete("softs")} />,
    <Energies
      key="energies"
      onLoadComplete={() => handleTabLoadComplete("energies")}
    />,
    <Currencies
      key="currencies"
      onLoadComplete={() => handleTabLoadComplete("currencies")}
    />,
  ];

  // Default tab titles as fallback
  const defaultTabTitles = [
    "Grains & Oilseeds",
    "Livestock",
    "Softs",
    "Energies",
    "Currencies",
  ];

  const tabTitles = [
    Config.futuresTabs?.grainsOilseeds || defaultTabTitles[0],
    Config.futuresTabs?.livestock || defaultTabTitles[1],
    Config.futuresTabs?.softs || defaultTabTitles[2],
    Config.futuresTabs?.energies || defaultTabTitles[3],
    Config.futuresTabs?.currencies || defaultTabTitles[4],
  ];

  // Map tab index to loading state key
  const tabIndexToLoadingKey = [
    "grainsOilSeeds",
    "livestock",
    "softs",
    "energies",
    "currencies",
  ];

  // Check if the current tab is loading
  const isCurrentTabLoading =
    tabLoadingStates[tabIndexToLoadingKey[currentTab]];

  // Handle tab switching
  const handleTabSwitch = (tabIndex) => {
    // If the current tab is still loading, don't allow switching
    if (isCurrentTabLoading) {
      return;
    }
    setTab(tabIndex);
  };

  //since color is coming from Config, we have to declare styling for injected htmls
  const css = `
    .marketview_quoteboard .marketview_title {
        background: ${Config.styles.primaryColor};
    }
    .marketview_quoteboard .marketview_title a {
        color: ${Config.styles.homeFontColor};
    }
  `;

  const SkeletonCard = () => (
    <div className="m-5 w-[300px] tablet:w-[400px] shadow-md rounded-xl animate-pulse">
      <div className="h-8 rounded-t-xl bg-gray-300"></div>
      <div className="p-4">
        {[...Array(10)].map((_, i) => (
          <div key={i} className="flex justify-between py-2">
            <div className="h-5 bg-gray-200 rounded w-1/3"></div>
            <div className="h-5 bg-gray-200 rounded w-1/4"></div>
            <div className="h-5 bg-gray-200 rounded w-1/6"></div>
          </div>
        ))}
      </div>
    </div>
  );

  useEffect(() => {
    if (process.env.REACT_APP_RESPONSIVE_IFRAME === "true") {
      const script = document.createElement("script");

      script.src = "/responsive-iframe.js";
      script.async = true;

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  useEffect(() => {
    // Set a timeout to simulate loading delay
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <style>{css}</style>
      <ul className="pt-56 px-6 flex flex-col justify-center tablet:flex-row flex-wrap text-sm font-medium text-center text-gray-500 dark:text-gray-400">
        {tabTitles.map((title, index) => (
          <li className="mr-2 text-lg" key={index}>
            <button
              className={`inline-block py-2 px-4 rounded-lg hover:text-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800 dark:hover:text-white ${
                isCurrentTabLoading && currentTab === index
                  ? "cursor-not-allowed"
                  : ""
              }`}
              style={
                currentTab === index
                  ? {
                      backgroundColor: Config.styles.primaryColor,
                      color: "white",
                    }
                  : {}
              }
              onClick={() => handleTabSwitch(index)}
              disabled={isCurrentTabLoading}
            >
              {title}
            </button>
          </li>
        ))}
      </ul>

      {isInitialLoading ? (
        <div className="flex justify-center flex-wrap">
          {[...Array(6)].map((_, index) => (
            <SkeletonCard key={index} />
          ))}
        </div>
      ) : (
        tabs[currentTab]
      )}
      <Header />
    </>
  );
};

export default Futures;
